(ns app.domain.phase-result.model
  (:require [core.db.child-entity :as child]))

(def ^{:arglists '([phase-entity])} get-result
  (child/child-entity-of-type-fn :entity.type/phase-result))
